module.exports = __webpack_public_path__ + "public/hws/images/loginimg_zh-cn.png";


//////////////////
// WEBPACK FOOTER
// ./public/hws/images/loginimg_zh-cn.png
// module id = 65
// module chunks = 0